import QuestionBubbleIcon from '../../../images/question-bubble.svg?component';
import ROUTE_NAMES from '../routeNames';
import SECTION_NAMES from '../sectionNames';
import { usePermissionsStore } from '@/vue/stores/permissions';

const meta = {
    title: SECTION_NAMES.HELP,
    icon: QuestionBubbleIcon,
    permissions: (): string[] => [usePermissionsStore().allPermissions.adminHelp],
};

export default [
    {
        path: '',
        name: ROUTE_NAMES.ADMIN_HELP_LIST,
        component: (): Promise<unknown> => import('../../views/admin/AdminHelp/AdminHelpList.vue'),
        meta,
    },
    {
        path: 'edit/:id',
        name: ROUTE_NAMES.ADMIN_HELP_VIEW,
        component: (): Promise<unknown> => import('../../views/admin/AdminHelp/AdminHelpForm.vue'),
        meta,
    },
    {
        path: 'new',
        name: ROUTE_NAMES.ADMIN_HELP_NEW,
        component: (): Promise<unknown> => import('../../views/admin/AdminHelp/AdminHelpForm.vue'),
        meta,
    },
    {
        path: 'help-contact/new',
        name: ROUTE_NAMES.ADMIN_HELP_CONTACT_NEW,
        component: (): Promise<unknown> => import('../../views/admin/AdminHelp/AdminHelpContactForm.vue'),
        meta: {
            ...meta,
            permissions: (): string[] => [usePermissionsStore().allPermissions.adminHelpAdd],
        },
    },
    {
        path: 'help-contact/:id/edit',
        name: ROUTE_NAMES.ADMIN_HELP_CONTACT_EDIT,
        component: (): Promise<unknown> => import('../../views/admin/AdminHelp/AdminHelpContactForm.vue'),
        meta: {
            ...meta,
            permissions: (): string[] => [usePermissionsStore().allPermissions.adminHelpEdit],
        },
    },
    {
        path: 'help-contact/:id/delete',
        name: ROUTE_NAMES.ADMIN_HELP_CONTACT_DELETE,
        component: (): Promise<unknown> => import('../../views/admin/AdminHelp/AdminHelpContactForm.vue'),
        meta: {
            ...meta,
            permissions: (): string[] => [usePermissionsStore().allPermissions.adminHelpDelete],
        },
    },
];
